import { memo } from 'react'
import { FormattedMessage } from 'react-intl'

import { homeDeviceInformationMessages as messages } from '../messages'
import {
  CardContentWrapper,
  CardInformation,
  CardInformationRow,
  CardInformationTitle,
  CardInformationValue,
} from '../styles'
import { SpinnerContainer } from 'features/home/components/HomeStatus/SubInfo/ConnectedApps/styles'
import { Spinner } from 'components/Loader'
import SignalIcon, { getCellStatus } from './SignalIcon'

interface DeviceInformationCardProps {
  rsrp: number | undefined
  rsrq: number | undefined
  loading: boolean
  order: number
}

function DeviceInformationCard({
  rsrp,
  rsrq,
  loading,
  order,
}: DeviceInformationCardProps) {
  if (loading) {
    return (
      <CardInformation order={order}>
        <CardContentWrapper>
          <SpinnerContainer>
            <Spinner />
          </SpinnerContainer>
        </CardContentWrapper>
      </CardInformation>
    )
  }
  const status = getCellStatus(rsrp, rsrq)

  return (
    <CardInformation order={order} bgColor={status.bgColor}>
      <CardContentWrapper>
        <CardInformationTitle>
          <FormattedMessage {...messages.signalStrength} />
        </CardInformationTitle>
        <CardInformationValue color={status.textColor}>
          <CardInformationRow>
            <FormattedMessage {...status.text} />
            <SignalIcon rsrp={rsrp} rsrq={rsrq} />
          </CardInformationRow>
        </CardInformationValue>
      </CardContentWrapper>
    </CardInformation>
  )
}

export default memo(DeviceInformationCard)
